import { Col, Row, Table, Tooltip, Checkbox } from "antd";
import React, { useEffect, useState } from "react";
import { Button, Modal, Form, Input, Select, DatePicker } from "antd";
import { useMutation } from "react-query";
import { useDispatch, useSelector } from "react-redux";
import {
  DeleteOutlined,
  UploadOutlined,
  LinkOutlined
} from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import HeadingBack from "../../../component/HeadingBack";
import { usePermission } from "../../../hooks/usePermission";
import { AbhaServices } from "../../../redux/Services";
import AbhaLinkedFilter from "../AbhaFilter";
import moment from "moment";
import dayjs from "dayjs";
import {
  AbhaLinkedNotify,
  uploadReport
} from "../../../redux/Services/AbhaLinkded";
import { UserId, encryptedData } from "../../../utils/";
import {
  PasswordRule,
  ValidateOnlyJson,
  ValidateOnlyPdfUrl,
  preventHtml
} from "../../../utils/validation";

const BUNDLE_TYPE_MAP = {
  DIAGNOSTIC_REPORT: 1,
  PRESCRIPTION: 2,
  DISCHARGE_SUMMARY: 3,
  OP_CONSULTATION: 4,
  WELLNESS_RECORD: 5,
  IMMUNIZATION: 6,
  HEALTH_DOCUMENT: 7,
  OTHER: 8
};
const AbhaCreated = () => {
  const filename = "ABHA Address Linked";
  const [FilteredData, setFilteredData] = useState([]);
  const [limit, setLimit] = useState(10);
  const [offset, setOffset] = useState(0);
  const permission = usePermission("HIP Dashboard", "List");
  const [form] = Form.useForm();
  const [show, setShow] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [page, setPage] = useState(1);
  const [currentPage, setCurrentPage] = useState(1);
  const [filter, setFilter] = useState({});
  const [modal1Open, setModal1Open] = useState(false);
  const [modal2open, setModal2Open] = useState(false);
  const [raw, setRaw] = useState({});
  const [ModalNotify, setModalNotify] = useState(false);
  const [linked, setLinked] = useState(false);
  const [num, setNum] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  // const { mutate: getabhaCreatedList, isLoading } = useMutation((data) =>
  //   dispatch(AbhaServices.abhaCreatedList(data, user, limit, currentPage))
  // );
  const { mutate: Notify, isLoading: addLoading } = useMutation((data) =>
    dispatch(AbhaLinkedNotify(data, navigate))
  );
  const { mutate: UploadReport } = useMutation((data) =>
    dispatch(uploadReport(data, navigate))
  );
  const abhaCreatedList = useSelector(
    (state) => state.abhaCreated.abhaCreatedList || []
  );
  const totalabhaCreatedList = useSelector(
    (state) => state.abhaCreated.totalabhaCreatedList || ""
  );
  const { Option } = Select;
  const user = {
    UserId: UserId
  };
  const randomNumberInRange = (min, max) => {
    return Math.floor(Math.random() * (max - min + 101)) + min;
  };
  const disabledDate = (current) => {
    return current && current > dayjs().endOf("day");
  };
  const onChange = (value, dateString) => {
    // console.log('Selected Time: ', value);
    // console.log('Formatted Selected Time: ', dateString);
  };
  const onOk = (value) => {
    // console.log('onOk: ', value);
  };
  const isLinked = (e) => {
    // console.log(`isLinked = ${e.target.checked}`);
    setLinked(e.target.checked);
    // console.log(linked)
  };
  // console.log(linked,'kk')

  var rawData = JSON.parse(raw?.raw_data || "{}");
  
  console.log(raw,rawData, "rawDatarawData");
  
  form.setFieldsValue({ phr: raw?.health_id });
  form.setFieldsValue({ patientName: rawData?.name||rawData?.fullname });
  const handleSubmit = (values) => {
    // console.log(raw, "((()))))");

    var rawData = JSON.parse(raw?.raw_data || "{}");
    var dobYear = rawData.yearOfBirth;
    var dobMonth =
      rawData.monthOfBirth > 9
        ? rawData.monthOfBirth
        : "0" + rawData.monthOfBirth;
    var dobDay =
      rawData.dayOfBirth > 9 ? rawData.dayOfBirth : "0" + rawData.dayOfBirth;
    const formatedDate = values.reportDateTime
      ? moment(values.reportDateTime).format("YYYY-MM-DD H:mm")
      : null;
    console.log(values, "valuesvalues");
    
    let nameArray = values.patientName.split(" ");
    let fhirPayload = {
      patinetId: `${raw?.patient_id}`,
      mobileNumber: `${rawData?.mobile ||rawData.mobileNo || ""}`,
      firstName: `${rawData?.firstName||nameArray[0] || ""}`,
      lastName: `${rawData?.lastName ||nameArray.length > 1 ? nameArray[nameArray.length - 1] : ""||""}`,
      middleName:
        nameArray.length > 2
          ? nameArray.slice(1, nameArray.length - 1).join(" ")
          : "",
      dob:rawData.yearOfBirth?  dobYear + "-" + dobMonth + "-" + dobDay:raw.patient_dob,
      gender: `${rawData?.gender || ""}`,
      abhaAddress: `${raw?.health_id}`,
      abhaNumber: raw?.heathid_no
    };
    let hiuId = "LPL";
    let payload = {
      authMode: "DEMOGRAPHICS",
      purpose: "KYC_AND_LINK",
      type: "HIU",
      phrId: `${raw?.health_id}`,
      referenceType: "Consent Request",
      lplLinkReference: `${raw?.health_id || ""}`,
      platform: `${raw?.platform || ""}`,
      platformType: `${raw?.platform_type || ""}`,
      patientReference: `${raw?.patient_id || ""}`,
      careContextReference: `${num || ""}`,
      linkNNotify: linked,
      version: "v1",
      query: {
        id: `${rawData?.healthId || ""}`,
        purpose: "KYC_AND_LINK",
        requester: {
          type: "HIU",
          id: hiuId || ""
        },
        demographic: {
          name: `${rawData?.name||rawData?.fullname || ""}`,
          mobile_no: `${rawData?.mobile || ""}`,
          gender: `${rawData?.gender || ""}`,
          dateOfBirth: dobYear + "-" + dobMonth + "-" + dobDay
        }
      }
    };
    let _data = {
      ...values,
      ...fhirPayload,
      payload,
      bundleTypeCode: values.bundleType
        ? BUNDLE_TYPE_MAP[values.bundleType] || null
        : null
    };
    if (formatedDate) {
      _data.reportDateTime = formatedDate;
    }
    _data.visitId = values.visitId;

    // return false
    console.log(_data, "finaldatafinaldata");
    
    UploadReport(_data);
    if (linked === true) {
    }
  };
  //  console.log(form.getFieldValue("labNumber"))
  // const handleNotify = () => {
  //   let hiuId = "LPL";
  //   var rawData = JSON.parse(raw?.raw_data || "{}");
  //   var dobYear = rawData.yearOfBirth;
  //   var dobMonth =
  //     rawData.monthOfBirth > 9
  //       ? rawData.monthOfBirth
  //       : "0" + rawData.monthOfBirth;
  //   var dobDay =
  //     rawData.dayOfBirth > 9 ? rawData.dayOfBirth : "0" + rawData.dayOfBirth;
  //   const lab_number = form.getFieldValue("labNumber");
  //   let payload = {
  //     authMode: "DEMOGRAPHICS",
  //     purpose: "KYC_AND_LINK",
  //     type: "HIU",
  //     phrId: `${raw?.health_id}`,
  //     referenceType: "Consent Request",
  //     lplLinkReference: `${raw?.health_id || ""}`,
  //     platform: `${raw?.platform || ""}`,
  //     platformType: `${raw?.platform_type || ""}`,
  //     patientReference: `${raw?.reference_id || ""}`,
  //     careContextReference: `${lab_number || ""}`,
  //     version: "v1",
  //     query: {
  //       id: `${rawData?.healthId || ""}`,
  //       purpose: "KYC_AND_LINK",
  //       requester: {
  //         type: "HIU",
  //         id: hiuId || ""
  //       },
  //       demographic: {
  //         name: `${rawData?.name || ""}`,
  //         mobile_no: `${rawData?.mobile || ""}`,
  //         gender: `${rawData?.gender || ""}`,
  //         dateOfBirth: dobYear + "-" + dobMonth + "-" + dobDay
  //       }
  //     }
  //   };

  //   let _data = { ...payload };
  //   _data.customToken = true;

  //   Notify(_data);
  // };
  useEffect(() => {
    // getabhaCreatedList(filter);
    // console.log(filter, "===(()");

    AbhaServices.abhaCreatedList({ ...filter, currentPage, limit }, dispatch);

    return () => {};
  }, [filter, offset, limit, currentPage]);

  useEffect(() => {
    if (abhaCreatedList && abhaCreatedList.length > 0) {
      var data = [];
      abhaCreatedList.map((value, index) => {
        var item = {
          sno: value?.sno,
          id: value?.id,
          log_type: value?.log_type,
          requestor: value?.requestor,
          patient_name: value?.patient_name,
          reference_id: value?.reference_id,
          mobile_no: value?.mobile_no,
          heathid_no: value?.heathid_no,
          health_id: value?.health_id,
          createdAt: value?.createdAt,
          updatedAt: value?.updatedAt
        };

        data.push(item);
      });
      setFilteredData(data);
    }
    return () => {};
  }, [abhaCreatedList]);

  const regex = /^[0-9]{4,9}$/;

  const headers = [
    { label: "S.No.", key: "sno" },
    { label: "Log Id", key: "id" },
    { label: "Log Type", key: "log_type" },
    { label: "Requester (HIU/HIP)", key: "requestor" },
    { label: "Patient Name", key: "patient_name" },
    { label: "Patient Id", key: "reference_id" },
    { label: "Mobile Number", key: "mobile_no" },
    { label: "ABHA Number", key: "heathid_no" },
    { label: "ABHA Address", key: "health_id" },
    { label: "Created At", key: "createdAt" },
    { label: "Updated At", key: "updatedAt" }
  ];
  const columns = [
    {
      title: "S.No.",
      dataIndex: "sno",
      key: "sno",
      className: "table_first_col",
      render: (value, item, index) => (page - 1) * limit + index + 1
    },
    {
      title: "Action",
      dataIndex: "action",
      key: "actiion",
      className: "abha-link-action",
      render: (value, item, index) => {
        return (
          // <> <Tooltip placement="top" title={"Link & Notify"}>
          //     <Button className="view-btn" type="primary" onClick={() => { setRaw(item || {}); setModalNotify(true); setNum((randomNumberInRange(101, 999))) }}><LinkOutlined /></Button>
          // </Tooltip> |
          //     <Button className="view-btn" type="primary" onClick={() => { setRaw(item); setModal2Open(true); setNum((randomNumberInRange(101, 999))) }} ><UploadOutlined /></Button></>
          <>
            <Tooltip placement="top" title={"Upload Report"}>
              <Button
                className="view-btn"
                type="primary"
                onClick={() => {
                  setRaw(item);
                  setModal2Open(true);
                }}
              >
                <UploadOutlined />
              </Button>
            </Tooltip>
          </>
        );
      }
    },
    {
      title: "Log Id",
      dataIndex: "id",
      key: "id",
      className: "table_status_col"
    },
    {
      title: "Log Type",
      dataIndex: "log_type",
      key: "log_type",
      className: "table_status_col",
      name: "type"
    },

    {
      title: "Token Number",
      dataIndex: "token",
      key: "token",
      className: "text-capitalize"
    },

    {
      title: "Patient Name",
      dataIndex: "raw_data",
      key: "raw_data",
      className: "table_status_col patient",
      render: (value, item, index) => {
        var RawData = JSON.parse(item?.raw_data);
        console.log(RawData, "rawData===");
        return RawData ? <span>{RawData.name||RawData.fullname}</span> : item.patient_name||item.fullname;
      }
    },

    {
      title: "Patient Id",
      dataIndex: "patient_id",
      key: "reference_id",
      className: "table_status_col patient"
    },
    {
      title: "Mobile Number",
      dataIndex: "mobile_no",
      key: "raw_data",
      className: "table_status_col patient",
      render: (value, item, index) => {
        var RawData = JSON.parse(item?.raw_data || "{}")?.mobile;
        return RawData ? <span>{item.mobile_no}</span> : item.mobile_no;
      }
    },
    {
      title: "ABHA Number",
      dataIndex: "heathid_no",
      key: "health_id",
      className: "abha-link-date"
    },
    {
      title: "ABHA Address",
      dataIndex: "health_id",
      key: "health_id",
      width: 200
    },
    {
      title: "Created At",
      dataIndex: "createdAt",
      key: "createdAt",
      className: "abha-link-date",
      render: (value, item, index) => {
        return <>{moment.utc(item.createdAt).format("DD-MM-YYYY H:mm:ss")}</>;
      }
    },
    {
      title: "Updated At",
      dataIndex: "updatedAt",
      key: "updatedAt",
      className: "abha-link-date",
      render: (value, item, index) => {
        return <>{moment.utc(item.updatedAt).format("DD-MM-YYYY H:mm:ss")}</>;
      }
    },
    {
      title: "Requested Data",
      dataIndex: "action",
      key: "action",
      className: "table_status_col",
      render: (value, item, index) => {
        return (
          <>
            <Button
              className="view-btn"
              type="primary"
              onClick={() => {
                setRaw(JSON.parse(item?.raw_data || "{}"));
                setModal1Open(true);
              }}
            >
              {" "}
              View
            </Button>
          </>
        );
      }
    }
  ];
  return (
    <div>
      <Row gutter={[10, 10]} align={"middle"}>
        <Col lg={3} md={24} sm={24} xs={24}>
          <HeadingBack
            title={"ABHA Address Linked"}
            subHeading={`Records ${totalabhaCreatedList || 0}`}
          />
        </Col>
        <Col lg={19} md={12} sm={24} xs={24}>
          <AbhaLinkedFilter
            filter={filter}
            setFilter={setFilter}
            setPage={setPage}
            headers={headers}
            FilteredData={FilteredData}
            setFilteredData={setFilteredData}
            filename={filename}
            enableScanFilter={true}
          />
        </Col>
      </Row>
      <div className="tableResponsive mt-10">
        <Table
          rowKey="Id"
          className={
            isLoading
              ? "table antd_table no_data_found_hide"
              : "table antd_table"
          }
          scroll={{ x: "max-content" }}
          bordered
          columns={columns}
          dataSource={
            Array.isArray(abhaCreatedList) && abhaCreatedList?.length > 0
              ? abhaCreatedList
              : []
          }
          pagination={{
            current: currentPage,
            pageSize: limit,
            total: totalabhaCreatedList,
            onChange(current, pageSize) {
              setPage(current);
              setCurrentPage(current);
              setOffset(() => (currentPage - 1) * limit);
            },
            hideOnSinglePage: true
            // showSizeChanger: true,
          }}
        />
      </div>

      <Modal
        style={{
          top: 20
        }}
        open={modal1Open}
        onOk={() => setModal1Open(false)}
        onCancel={() => {
          setRaw({});
          setModal1Open(false);
        }}
        footer={null}
      >
        <pre>{JSON.stringify(raw, null, 2)}</pre>
      </Modal>
      {/* <Modal
                style={{
                    top: 20,
                }}
                open={ModalNotify}
                onOk={() => { handleNotify(); setModalNotify(false) }}
                onCancel={() => setModalNotify(false)}
                okText="Yes"
            >
                <h3>Are sure want to link and notify to user?</h3>
            </Modal> */}
      <Modal
        style={{
          top: 20
        }}
        open={modal2open}
        onOk={() => setModal2Open(false)}
        onCancel={() => setModal2Open(false)}
        footer={null}
        width={1000}
      >
        <Form
          form={form}
          name="basic"
          layout={"vertical"}
          autoComplete="off"
          initialValues={{ Status: "1" }}
          onFinish={handleSubmit}
        >
          <Row gutter={[24, 0]}>
            <Col lg={12} md={24} sm={24} xs={24}>
              <Form.Item label="Patient Name" name="patientName">
                <Input
                  type="text"
                  autoComplete="new-off"
                  className="form-control"
                  placeholder="Patient Name"
                  readOnly
                />
              </Form.Item>
            </Col>
            <Col lg={12} md={24} sm={24} xs={24}>
              <Form.Item label="Abha Address" name="phr">
                <Input
                  type="text"
                  autoComplete="new-off"
                  className="form-control"
                  placeholder="Password"
                  readOnly
                />
              </Form.Item>
            </Col>
            <Col lg={12} md={24} sm={24} xs={24}>
              <Form.Item
                label="Report Number"
                name="reportNumber"
                rules={[
                  {
                    required: true,
                    message: "Report Number is required"
                  }
                ]}
              >
                <Input
                  // type="Number"
                  maxLength={8}
                  autoComplete="new-off"
                  className="form-control"
                  placeholder="Report Number"
                  minLength={4}
                />
              </Form.Item>
            </Col>
            {/* <Col lg={12} md={24} sm={24} xs={24}>
              <Form.Item
                label="Password"
                name="password"
                className="up-pass"
                rules={PasswordRule()}
              >
                <Input.Password
                  type={show ? "text" : "password"}
                  autoComplete="new-off"
                  className="form-control"
                  placeholder="Password"
                />
              </Form.Item>
            </Col> */}
            {/* <Col lg={12} md={24} sm={24} xs={24}>
              <Form.Item
                label="PDF URL"
                name="pdfUrl"
                rules={[
                  { required: true, message: "PDF URL is required" },
                  { validator: ValidateOnlyPdfUrl }
                ]}
              >
                <Input
                  type="link"
                  autoComplete="new-off"
                  className="form-control"
                  placeholder="PDF URL"
                  onInput={preventHtml}
                />
              </Form.Item>
            </Col> */}
            <Col lg={12} md={24} sm={24} xs={24}>
              <Form.Item
                label="Visit ID"
                name="visitId"
                placeholder="Please enter Visit ID"
                rules={[{ required: true, message: "Visit ID is required" }]}
                width={100}
              >
                <Input
                  type="link"
                  autoComplete="new-off"
                  className="form-control"
                  placeholder="Visit ID"
                  onInput={preventHtml}
                  minLength={4}
                  maxLength={8}
                />
                {/* <DatePicker
                  showTime={{
                    format: "HH:mm"
                  }}
                  style={{
                    width: "100%"
                  }}
                  format="YYYY-MM-DD HH:mm"
                  onChange={onChange}
                  onOk={onOk}
                  disabledDate={disabledDate}
                /> */}
              </Form.Item>
            </Col>
            <Col lg={12} md={24} sm={24} xs={24}>
              <Form.Item
                label="Bundle Type"
                name="bundleType"
                rules={[
                  { required: true, message: "Bundle Type is required" }
                ]}
              >
                <Select placeholder="Select Bundle Type">
                  <Option value="DIAGNOSTIC_REPORT">Diagnostic Report</Option>
                  <Option value="PRESCRIPTION">Prescription</Option>
                  <Option value="DISCHARGE_SUMMARY">Discharge Summary</Option>
                  <Option value="OP_CONSULTATION">OP Consultation</Option>
                  <Option value="WELLNESS_RECORD">Wellness Record</Option>
                  <Option value="IMMUNIZATION">Immunization</Option>
                  <Option value="HEALTH_DOCUMENT">Health Document</Option>
                  <Option value="OTHER">Other</Option>
                </Select>
              </Form.Item>
            </Col>
            <Col lg={24} md={24} sm={24} xs={24}>
              <Form.Item
                label="FHIR Data"
                name="fhirData"
                rules={[
                  { required: false, message: "FHIR Data is required" },
                  { validator: ValidateOnlyJson }
                ]}
              >
                <textarea
                  type="text"
                  autoComplete="new-off"
                  className="form-control"
                  placeholder="FHIR Data"
                  onInput={preventHtml}
                />
              </Form.Item>
            </Col>
            <Col lg={24} md={24} sm={24} xs={24}>
              <Checkbox onChange={isLinked}>Link and Notify </Checkbox>
            </Col>
          </Row>
          <div className="text-center">
            <button
              key="submit"
              type="submit"
              className="gradient-button w-auto"
            >
              Submit
            </button>
          </div>
        </Form>
      </Modal>
    </div>
  );
};

export default AbhaCreated;
